import { inject, Injectable } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { ToastService } from './toast.service';

@Injectable({ providedIn: 'root' })
export class CopyService {
  private readonly toastService: ToastService = inject(ToastService);

  copyToClipboard(value: string): Observable<void> {
    return from(navigator.clipboard.writeText(value)).pipe(
      switchMap(() =>
        this.toastService.showToast({
          message: 'Skopiowano do schowka',
          position: 'bottom',
          duration: 2000
        })
      )
    );
  }
}
